import React, { useRef, useEffect } from 'react';
import '../../vip/vip.css';

export default function VipConversionForm({ vm, theme = 'light', onClose, modal = false }) {
  const { vipBalance, level, amount, status, errorText, message, converting, onAmountChange, onConvert, minRequired, resetFeedback, canSubmit } = vm;
  const inputRef = useRef(null);
  const modalRef = useRef(null);

  useEffect(() => {
    if (status === 'SUCCESS' && modalRef.current) {
      modalRef.current.focus();
    }
  }, [status]);

  const disabled = converting || !canSubmit;
  const showError = status === 'ERROR' && errorText;
  const showSuccess = status === 'SUCCESS';

  const container = (
    <div className={`vip-module ${modal ? '' : 'vip-theme-' + theme}`} style={modal ? {} : { marginTop: '16px' }}>
      <div className="vip-balance" aria-label="VIP Balance">VIP Points: {vipBalance}</div>
      <div className="vip-level" aria-label="VIP Level">Level: {level || '—'}</div>
      <form className="vip-convert-form" onSubmit={(e) => { e.preventDefault(); onConvert(); }}>
        <label htmlFor="vipAmount" className="vip-input-label">Convert VP</label>
        <input
          ref={inputRef}
          id="vipAmount"
          className="vip-input"
          inputMode="numeric"
          pattern="[0-9]*"
          value={amount}
          onChange={(e) => onAmountChange(e.target.value.replace(/[^0-9]/g, ''))}
          aria-describedby={showError ? 'vip-error' : undefined}
          aria-invalid={showError ? 'true' : 'false'}
          placeholder={`Min ${minRequired}`}
        />
        <div className="vip-preview" aria-live="polite">Will credit: {amount ? amount : 0}</div>
        <div className="vip-min-note">Minimum: {minRequired} | Balance: {vipBalance}</div>
        {showError && <div id="vip-error" className="vip-convert-error" role="alert">{errorText}</div>}
        <button
          type="submit"
          className="vip-convert-button"
          disabled={disabled}
          aria-busy={disabled ? 'true' : 'false'}
        >
          {converting ? 'Converting…' : 'Convert'}
        </button>
      </form>
      {(showSuccess || (status === 'ERROR' && message)) && (
        <div className={modal ? 'vip-inline-feedback' : 'vip-feedback-modal'}
          tabIndex={-1}
          ref={modalRef}
          role="dialog"
          aria-modal="true"
          aria-label="Conversion feedback">
          <div className="vip-feedback-content">
            <h2 className="vip-feedback-title">{showSuccess ? 'Conversion Successful' : 'Conversion Feedback'}</h2>
            <div className={showSuccess ? 'vip-success-text' : ''}>{message}</div>
            {showSuccess && <div className="vip-convert-anim" aria-hidden="true"><div className="vip-coin" /><div className="vip-coin" /><div className="vip-coin" /></div>}
            <button type="button" className="vip-close-btn" onClick={() => { resetFeedback(); if (onClose) onClose(); }}>Close</button>
          </div>
        </div>
      )}
    </div>
  );

  if (!modal) return container;

  return (
    <div className="vip-convert-modal-shell">
      <div className={`vip-convert-modal-panel vip-theme-${theme}`}> 
        <button aria-label="Close" type="button" className="vip-modal-close-x" onClick={() => { if (onClose) onClose(); }}>&times;</button>
        {container}
      </div>
    </div>
  );
}
